import { render, staticRenderFns } from "./OnlinePaiement.vue?vue&type=template&id=042836fc&"
import script from "./OnlinePaiement.vue?vue&type=script&lang=js&"
export * from "./OnlinePaiement.vue?vue&type=script&lang=js&"
import style0 from "./OnlinePaiement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports